<template>
  <v-dialog
    v-model="loadDialog"
    max-width="600"
  >
    <v-card>
      <v-container>
        <app-alert @dismissed="onDismissed" :text="error" v-if="error !== ''"></app-alert>
        <v-row  >
            <v-col class="text-center" >
                <h2 :style="`color:${color}`">Crear cuenta colaborador</h2>
            </v-col>
        </v-row>
        <v-row  >
            <v-col cols="5">
                <v-row justify="end">
                    <v-col cols="11">
                        <v-text-field
                            label="Email"
                            v-model="email"
                            :rules="[rules.required]"
                            prefix="*"
                        ></v-text-field>
                        <v-text-field
                            label="Contraseña"
                            v-model="password1"
                            :rules="[rules.required]"
                            prefix="*"
                        ></v-text-field>
                        <v-text-field
                            label="Confirmar contraseña"
                            v-model="password2"
                            :rules="[rules.required]"
                            prefix="*"
                        ></v-text-field>
                         <v-text-field
                            label="Foto url"
                            v-model="photoUrl"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="5">
                <v-row>
                    <v-col cols="11">
                         <v-text-field
                            label="Nombres"
                            v-model="firstName"
                            :rules="[rules.required]"
                            prefix="*"
                        ></v-text-field>
                        <v-text-field
                            label="Apellidos"
                            v-model="lastName"
                            :rules="[rules.required]"
                            prefix="*"
                        ></v-text-field>
                        <v-text-field
                            label="Teléfono"
                            v-model="phone"
                            type="number"
                            :rules="[rules.required]"
                            prefix="*"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row  style="position:relative">
            <v-col cols="12">
                <v-card-actions>
                    <v-col class="text-center" >
                        <v-btn
                        :color="color"
                        text
                        @click="closeDialog"
                        >Cancelar</v-btn>
                        <v-btn
                        :loading="onLoading"
                        :disabled="onLoading"
                        :color="color"
                        :dark="!onLoading"
                        @click="onSaveUser"
                        >Crear</v-btn>
                    </v-col>
                </v-card-actions>
            </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
/* eslint-disable no-console */
import { mdiDeleteOutline } from '@mdi/js'
import * as constants from '../../../constants.json'

export default {
  props: ['showSignUpDialog'],
  data () {
    return {
      email: '',
      firstName: '',
      lastName: '',
      password1: '',
      password2: '',
      phone: 0,
      photoUrl: '',
      deleteIcon: mdiDeleteOutline,
      color: constants.MAINCOLOR,
      colorTitle: '#525252',
      rules: {
        required: value => !!value || 'Campo requerido'
      },
      error: ''
    }
  },

  computed: {
    loadDialog () {
      return this.$store.getters.getOpenSignUpDialog
    },
    onLoading () {
      return this.$store.getters.getLoading
    }
  },

  methods: {
    async onSaveUser () {
      try {
        if (this.firstName.trim() === '' ||
            this.lastName.trim() === '' ||
            this.email.trim() === '' ||
            this.password1.trim() === '' ||
            this.password2.trim() === '') {
          this.error = 'Todos los campos son obligatorios.'
          console.log('Saving user')
          return
        } else if (this.password1 !== this.password2) {
          this.error = 'La contraseña no coincide.'
          return
        }

        await this.$store.dispatch('actionCreateNewCollab', {
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
          password: this.password1,
          phone: this.phone,
          photoUrl: this.photoUrl
        })
      } catch (error) {
        console.log(error)
        switch (error.code) {
          case 'auth/weak-password':
            this.error = 'La contraseña debe tener al menos 6 caracteres'
            break
          case 'auth/email-already-in-use':
            this.error = 'La dirección de email ya está siendo usada por otra cuenta'
        }
      }
    },

    closeDialog () {
      this.$store.commit('mutationOpenSignUpDialog', false)
    },

    onDismissed () {
      console.log('Dismissed Alert')
      this.error = ''
    }
  }
}
</script>
